import { render, staticRenderFns } from "./AddDiscountPackageDialog.vue?vue&type=template&id=17ed3de4&scoped=true"
import script from "./AddDiscountPackageDialog.vue?vue&type=script&lang=js"
export * from "./AddDiscountPackageDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDiscountPackageDialog.vue?vue&type=style&index=0&id=17ed3de4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ed3de4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17ed3de4')) {
      api.createRecord('17ed3de4', component.options)
    } else {
      api.reload('17ed3de4', component.options)
    }
    module.hot.accept("./AddDiscountPackageDialog.vue?vue&type=template&id=17ed3de4&scoped=true", function () {
      api.rerender('17ed3de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/AddDiscountPackageDialog.vue"
export default component.exports